/**
 * Swahili render vocabulary.
 *
 * Self-registering: importing this module makes the words available to
 * `render(node, 'sw')`. Kept separate from the profile so a parse-only
 * bundle can drop it — see lexicon-registry.ts for why that separation exists.
 */
import type { LanguageLexicon } from '../generators/profiles/types';
import { registerLexicon } from '../lexicon-registry';

export const swahiliLexicon: LanguageLexicon = {
  events: {
    blur: { primary: 'blur' },
    change: { primary: 'kubadilisha' },
    click: { primary: 'bonyeza' },
    dblclick: { primary: 'dblclick' },
    focus: { primary: 'lenga' },
    input: { primary: 'ingizo' },
    keydown: { primary: 'kitufe_shuka' },
    keypress: { primary: 'keypress' },
    keyup: { primary: 'kitufe_juu' },
    load: { primary: 'pakia' },
    mousedown: { primary: 'panya_shuka' },
    mouseenter: { primary: 'panya_ingia' },
    mouseleave: { primary: 'panya_toka' },
    mousemove: { primary: 'panya_sogea' },
    mouseout: { primary: 'panya_nje' },
    mouseover: { primary: 'sogeza juu' },
    mouseup: { primary: 'panya_juu' },
    reset: { primary: 'reset' },
    resize: { primary: 'badilisha_ukubwa' },
    scroll: { primary: 'sogeza' },
    submit: { primary: 'wasilisha' },
    touchcancel: { primary: 'touchcancel' },
    touchend: { primary: 'touchend' },
    touchmove: { primary: 'touchmove' },
    touchstart: { primary: 'touchstart' },
    unload: { primary: 'shuka' },
  },
  logical: {
    and: { primary: 'na' },
    changes: { primary: 'inabadilika' },
    contains: { primary: 'ina' },
    else: { primary: 'sivyo' },
    end: { primary: 'mwisho' },
    equals: { primary: 'sawa' },
    exists: { primary: 'ipo' },
    has: { primary: 'ana' },
    have: { primary: 'nina' },
    includes: { primary: 'pamoja' },
    is: { primary: 'ni' },
    live: { primary: 'mubashara' },
    matches: { primary: 'inafanana' },
    not: { primary: 'si' },
    or: { primary: 'au' },
    otherwise: { primary: 'vinginevyo' },
    then: { primary: 'kisha' },
    when: { primary: 'wakati' },
    where: { primary: 'wapi' },
  },
  temporal: {
    h: { primary: 'sa' },
    hour: { primary: 'saa' },
    hours: { primary: 'masaa' },
    millisecond: { primary: 'millisekunde' },
    milliseconds: { primary: 'millisekunde' },
    min: { primary: 'dk' },
    minute: { primary: 'dakika' },
    minutes: { primary: 'dakika' },
    ms: { primary: 'ms' },
    s: { primary: 's' },
    second: { primary: 'sekunde' },
    seconds: { primary: 'sekunde' },
    times: { primary: 'mara' },
  },
  values: {
    body: { primary: 'mwili' },
    detail: { primary: 'maelezo' },
    document: { primary: 'hati' },
    element: { primary: 'kipengele' },
    event: { primary: 'tukio' },
    false: { primary: 'uongo' },
    it: { primary: 'hiyo' },
    its: { primary: 'yake' },
    me: { primary: 'mimi' },
    my: { primary: 'yangu' },
    myself: { primary: 'mimi mwenyewe' },
    null: { primary: 'null' },
    result: { primary: 'matokeo' },
    target: { primary: 'lengo' },
    true: { primary: 'kweli' },
    undefined: { primary: 'haijafafanuliwa' },
    value: { primary: 'thamani' },
    window: { primary: 'dirisha' },
    you: { primary: 'wewe' },
    your: { primary: 'yako' },
    yourself: { primary: 'wewe mwenyewe' },
  },
  attributes: {
    attribute: { primary: 'sifa' },
    attributes: { primary: 'sifa' },
    class: { primary: 'darasa' },
    classes: { primary: 'madarasa' },
    properties: { primary: 'mali' },
    property: { primary: 'mali' },
    style: { primary: 'mtindo' },
    styles: { primary: 'mitindo' },
  },
  expressions: {
    at: { primary: 'katika' },
    characters: { primary: 'herufi' },
    children: { primary: 'watoto' },
    closest: { primary: 'karibu' },
    empty: { primary: 'tupu' },
    'ends with': { primary: 'huisha na' },
    first: { primary: 'kwanza' },
    'ignoring case': { primary: 'puuza herufi kubwa ndogo' },
    'joined by': { primary: 'kuunganishwa kwa' },
    last: { primary: 'wamwisho' },
    'mapped to': { primary: 'kubadilishwa kuwa' },
    next: { primary: 'ijayo' },
    no: { primary: 'hakuna' },
    parent: { primary: 'mzazi' },
    prev: { primary: 'awali' },
    previous: { primary: 'iliyopita' },
    random: { primary: 'nasibu' },
    some: { primary: 'baadhi' },
    'sorted by': { primary: 'kupangwa kwa' },
    'split by': { primary: 'kugawanywa kwa' },
    'starts with': { primary: 'huanza na' },
    within: { primary: 'ndani_ya' },
  },
};

registerLexicon('sw', swahiliLexicon);
